import React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import RelatedObjects from '../../../../../components/ui/RelatedObjects/RelatedObjects';
import useHousingStockRequests from '../../../../../queries/useHousingStockRequests';
import {
  setSelectedRequestId,
  setRequestDrawerVisible,
} from '../../../../../../../actions/requestCardActions';
import styles from '../HouseInfo.module.scss';

const HouseRelatedObjects = () => {
  const params = useParams();

  const dispatch = useDispatch();

  const houseId = Number(params.pageId);

  const { data: requests, isFetching: isRequestsFetching } =
    useHousingStockRequests({ houseId }, { staleTime: Infinity });

  const handleItemClick = (requestId) => {
    dispatch(setSelectedRequestId(requestId));
    dispatch(setRequestDrawerVisible(true));
  };

  return (
    <RelatedObjects
      data={requests}
      loading={isRequestsFetching}
      onItemClick={handleItemClick}
      cardSize={7}
    />
  );
};

export default HouseRelatedObjects;
